








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-pencil',

})
export default class IPencil extends Vue {

  @Prop({type: [String], default: '#2D9CDB'}) protected color!: string

}

